import React from "react"
import "./separator.scss"

const Separator = (props) => {
  const { ...rest } = props
  return <div {...rest} className="separator-container" />
}

export default Separator
